fx.ns("filters", class MediaThemeTagFilter extends fx.Filter {

	constructor()
	{
        super();
    }

    get tagid()
    {
        return this._tagid;
    }

    set tagid(val)
    {
        this._tagid = val;
        this._changed = true;
    }

   
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        if (this.tagid)
        {
            for (let i = 0; i < this.rawData.length; i++)
            {
                let media = this.rawData.getItemAt( [i] );

                if (media.theme_tag_id == this.tagid)
                    this.transformedData.push( media );
            }
        }

		return this.transformedData;
	}	
});